var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_69",
    "data-name": "Grupo 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.227,
    height: 36.706,
    viewBox: "0 0 38.227 36.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1083",
    "data-name": "Ret\\xE2ngulo 1083",
    width: 38.227,
    height: 36.706,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_68",
    "data-name": "Grupo 68",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_16",
    "data-name": "Caminho 16",
    d: "M38.227,19.922c-.1.7-.153,1.41-.291,2.1a18.6,18.6,0,0,1-11.72,14.219,10.572,10.572,0,0,1-1.052.378.956.956,0,0,1-1.36-1c0-1.708.022-3.416.009-5.124a4.587,4.587,0,0,0-1.244-3.359c.541-.088,1.046-.162,1.548-.255a10.318,10.318,0,0,0,3.459-1.23,7.346,7.346,0,0,0,3.481-5.442,11.6,11.6,0,0,0,.1-3.573,6.976,6.976,0,0,0-1.661-3.614.483.483,0,0,1-.1-.53,7.045,7.045,0,0,0-.2-4.474c-.106-.3-.35-.284-.544-.244a11.693,11.693,0,0,0-2.12.529c-.833.344-1.6.849-2.4,1.264a.858.858,0,0,1-.546.088,18.53,18.53,0,0,0-8.975,0,.842.842,0,0,1-.574-.116,11.908,11.908,0,0,0-3.756-1.686c-1.129-.236-1.255-.161-1.532.94A6.638,6.638,0,0,0,8.8,12.588a.425.425,0,0,1-.064.352,7.781,7.781,0,0,0-1.764,6.243,10.145,10.145,0,0,0,.91,3.524,7.191,7.191,0,0,0,4.624,3.787c.982.3,2,.47,3,.7a4.843,4.843,0,0,0-.53.765c-.206.448-.337.93-.511,1.394-.048.129-.109.313-.211.353a4.066,4.066,0,0,1-4.275-.324,6.261,6.261,0,0,1-1.159-1.348,3.924,3.924,0,0,0-2.754-1.86,2.066,2.066,0,0,0-.734.062c-.3.075-.365.291-.156.533a2.261,2.261,0,0,0,.532.463,4.835,4.835,0,0,1,2.063,2.531c.878,2.37,3.056,3.2,5.312,2.994.407-.038.812-.106,1.274-.167,0,.64,0,1.274,0,1.907,0,.349.01.7.012,1.047.005.961-.576,1.375-1.5,1.061A18.78,18.78,0,0,1,6.564,33a18.191,18.191,0,0,1-6.3-11.143,18.088,18.088,0,0,1,4.287-15.2A18.511,18.511,0,0,1,16.327.2a19.068,19.068,0,0,1,21.5,14.788c.162.765.224,1.551.334,2.328.017.12.043.239.065.359Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.8bde4d3b6cea6a643b24fe9252001e91.svg";
export { ForwardRef as ReactComponent };